import React, { useEffect } from 'react';

import Trans from 'components/Common/Translation/Trans';
import PadlockIcon from 'components/Common/Icons/Padlock';
import PaymentMethod from 'model/PaymentMethod';
import { apiUrls } from 'services/api-urls';
import { MethodProps } from 'types/PaymentFormType';

import styles from './Paypage.module.scss';

type Props = Pick<MethodProps, 'setPaymentMethod' | 'handleClick'>;

export default function PayPage({
  handleClick,
  setPaymentMethod,
}: Props): JSX.Element {
  useEffect(() => {
    void setPaymentMethod(PaymentMethod.cb);
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.cbLockIcon}>
        <PadlockIcon />
      </div>
      <div className={styles.cbContentInformation}>
        <Trans
          i18nKey={'CB_METHOD_INFORMATION'}
          namespace={'checkout'}
          additionalComponents={{
            learnMore: (
              <a
                className={styles.seeMore}
                href={apiUrls.getMediaPopin('/16.html')}
                onClick={handleClick}
              />
            ),
          }}
        />
      </div>
    </div>
  );
}
